import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
  map: {
    height: '50vh',
    border: '5px solid white'
  },
  noActionPin: {
    cursor: 'initial',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  submitCell: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontWeight: 600
  },
  submitCellDisable: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'not-allowed',
    fontWeight: 600,
    pointerEvents: 'none'
  },
}));

export default styles;

export const listItemTextPrimary = {
  fontSize: '1rem',
  fontWeight: 600,
};
